import { ArrowRight, Download, Link2, CheckCircle2, Images } from 'lucide-react';
import { toast } from 'sonner';
import { API } from '../../lib/constants';
import { Field } from '../AuthShell';
import { copyText } from '../../lib/clipboard';

export const RegistrationForm = ({ form, onChange, onNext }) => {
  const ready = form.name && form.email && form.phone;
  return (
    <div className="card-brutal fade-up" data-testid="registration-form">
      <div className="px-6 py-5 border-b-2 border-line">
        <h2 className="h-display text-xl">Your details</h2>
        <p className="text-sm text-slate-400 mt-1">Used only to label your album. Never sold, never shared.</p>
      </div>
      <div className="p-6 space-y-5">
        <Field label="Full name">
          <input data-testid="name-input" className="input" placeholder="Jane Doe" value={form.name} onChange={onChange('name')} />
        </Field>
        <Field label="Email address">
          <input data-testid="email-input" type="email" className="input" placeholder="jane@example.com" value={form.email} onChange={onChange('email')} />
        </Field>
        <Field label="Phone number">
          <input data-testid="phone-input" className="input" placeholder="+91 98765 43210" value={form.phone} onChange={onChange('phone')} />
        </Field>
        <button data-testid="continue-to-photo-btn" onClick={onNext} disabled={!ready} className="btn-primary w-full mt-2">
          Continue to selfie <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export const SuccessCard = ({ galleryId, userName, galleryPath }) => {
  const galleryUrl = `${window.location.origin}${galleryPath}`;

  const downloadQR = () => {
    const link = document.createElement('a');
    link.href = `${API}/qrcode/${galleryId}`;
    link.download = `gallery-${galleryId}-qr.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success('QR code downloaded');
  };

  const copyLink = async () => {
    (await copyText(galleryUrl)) && toast.success('Gallery link copied');
  };

  return (
    <div className="card-brutal-lime fade-up" data-testid="success-card">
      <div className="px-6 py-6 border-b-2 border-line flex items-start gap-4">
        <span className="w-11 h-11 bg-lime text-ink flex items-center justify-center shrink-0 border-2 border-lime">
          <CheckCircle2 className="w-6 h-6" />
        </span>
        <div>
          <h2 className="h-display text-xl">You're in, {userName}</h2>
          <p className="text-sm text-slate-400 mt-1">Save your album link or QR. As the photographers upload, every photo you're in appears here automatically.</p>
        </div>
      </div>
      <div className="p-6 grid sm:grid-cols-[200px_1fr] gap-6 items-start">
        <div className="bg-white p-3 border-2 border-white justify-self-center sm:justify-self-start shadow-[0_18px_40px_rgba(40,35,52,0.10)]">
          <img src={`${API}/qrcode/${galleryId}`} alt="Gallery QR" className="w-44 h-44" data-testid="qr-code-image" />
        </div>
        <div className="space-y-4 min-w-0">
          <div>
            <p className="label mb-2">Your gallery link</p>
            <code data-testid="gallery-link" className="block text-xs bg-ink border-2 border-line px-3 py-2.5 text-cyan break-all">
              {galleryUrl}
            </code>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <button data-testid="download-qr-btn" onClick={downloadQR} className="btn-ghost flex-1 !py-3">
              <Download className="w-4 h-4" /> Download QR
            </button>
            <button data-testid="copy-link-btn" onClick={copyLink} className="btn-ghost flex-1 !py-3">
              <Link2 className="w-4 h-4" /> Copy link
            </button>
          </div>
          <a data-testid="view-gallery-btn" href={galleryPath} className="btn-primary w-full">
            <Images className="w-4 h-4" /> Open my gallery
          </a>
        </div>
      </div>
    </div>
  );
};
